<template>
  <div class="shopping-cart">
    <p class="button-icon" v-if="cart.length > 0" v-on:click="OpenModal()">
      <img src="../../../../static/images/Ellipse 5.png" alt="" /><b
        class="total-item-cart"
        >{{ cart.length }}</b
      >
    </p>
    <!-- The Modal -->
    <div id="myModal-Cart" class="modal">
      <!-- Modal content -->
      <div class="modal-content" :class="[{ mb: mobile }]">
        <div class="top-close" v-if="mobile">
          <span v-on:click="CloseModal()" class="close">{{
            $t("new.title208")
          }}</span>
        </div>
        <span v-if="!mobile" v-on:click="CloseModal()" class="close">{{
          $t("new.title208")
        }}</span>
        <div class="cart-content">
          <div v-if="cart.length == 0">
            <img
              class="empty-cart"
              src="../../../../static/images/GHtrong2-xanh.png"
              width="150"
              alt="/"
            />
            <!-- <h3 style="text-align:center">{{ $t("new.title152") }} </h3> -->
          </div>
          <table class="cart-table" style="width:100%;">
            <tr
              id="item-course"
              v-for="(carts, index) in cart"
              :key="carts.courseId"
            >
              <td class="item-image">
                <img
                  v-if="carts.courseCover != ''"
                  class=""
                  :src="carts.courseCover"
                  :alt="carts.courseCover"
                />
                <img
                  v-else
                  src="../../../../static/images/temppic.jpg"
                  alt="temppic.jpg"
                />
              </td>
              <td class="item-title">
                <h3 style="color:#0071c5;line-height:20px">
                  {{ carts.courseName }}
                </h3>
                <div style="float:left">
                  <p>{{ $t("new.title145") }}:</p>
                  <p>{{ $t("new.title147") }}:</p>
                  <p v-if="carts.coursePrice >= 0">{{ $t("new.title153") }}:</p>
                </div>
                <div style="float:left;padding-left:10px;font-weight:600">
                  <p>{{ carts.timestudy }} {{ $t("new.title146") }}</p>
                  <p>{{ carts.totalless }} {{ $t("new.title154") }}</p>
                  <p v-if="carts.offSelf != 0" class="item-price-cart">
                    <span v-if="beforCurren">{{ $t("new.title121") }}</span
                    >{{
                      (carts.coursePrice - carts.coursePriceDiscount)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                    <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                  </p>
                  <p v-else class="item-price-cart">
                    <span v-if="beforCurren">{{ $t("new.title121") }}</span
                    >{{
                      carts.coursePrice
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                    <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                  </p>
                </div>
              </td>
              <td
                class="item-close"
                title="bỏ khóa học"
                style="width:10%"
                v-on:click="
                  CloseItemCourse(
                    index,
                    carts.coursePrice - carts.coursePriceDiscount
                  )
                "
              >
                &#10008;
              </td>
            </tr>

            <tr>
              <td colspan="3" class="item-total">
                <p>
                  {{ $t("new.title155") }} :
                  <span
                    ><b
                      ><span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        reduce.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{
                        $t("new.title121")
                      }}</span></b
                    ></span
                  >
                </p>
              </td>
            </tr>
          </table>

          <button
            v-if="cart.length > 0"
            class="submit"
            @click="NextPageSubsribeCart()"
          >
            {{ $t("new.title143") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CartCourse",
  props: {
    msg: String
  },
  data() {
    return {
      content: true,
      catalog: true,
      related: true,
      dataDetails: {},
      cartadd: {},
      cart: [],
      badge: 0,
      reduce: 0,
      afterCurren: false,
      beforCurren: false
    };
  },
  components: {},
  async created() {
    this.viewCart();
    this.checkCurren();
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    }
  },
  methods: {
    toggle(value) {
      if (value == "content") {
        this.content = !this.content;
      } else if (value == "related") {
        this.related = !this.related;
      } else {
        this.catalog = !this.catalog;
      }
    },
    OpenModal() {
      document.getElementById("myModal-Cart").style.display = "block";
    },
    CloseModal() {
      document.getElementById("myModal-Cart").style.display = "none";
    },
    CloseItemCourse() {
      document.getElementById("item-course").style.display = "none";
    },
    CloseItemCourse(id, price) {
      this.cart.splice(id, 1);
            if(this.reduce > 0 && price >= 0){
        this.reduce -= price;
      }
      this.saveCats();
    },
    NextPageSubsribeCart() {
      this.$router.push({
        path: "/home/subscribeSelfCourse",
        query: {}
      });
    },
    saveCats() {
      // for save in local storage set the below code
      let parsed = JSON.stringify(this.cart);
            localStorage.setItem("cart_" + this.$lang(), parsed);
      this.viewCart(); // by this function we can see all products are save in web },
    },
    // we put the below code in methods
    viewCart() {
            if (localStorage.getItem("cart_" + this.$lang())) 
            { 
                this.cart = JSON.parse(localStorage.getItem("cart_" + this.$lang()));
                // totall price in shopping cart
                this.reduce = 0;
                 for (let index = 0; index < this.cart.length; index++) {
                    if (this.cart[index].coursePrice < 0) {
                        continue;
                    }
                    if(this.cart[index].offSelf != 0 && this.cart[index].coursePrice > 0){
                        this.reduce += (this.cart[index].coursePrice - this.cart[index].coursePriceDiscount)
                    }
                    else{
                        this.reduce += this.cart[index].coursePrice
                    }
                }
            } 
        },
        // Curency position
        checkCurren(){
             if(this.$lang()){
                    if(this.$lang() == 3 || this.$lang() == 1){
                    this.beforCurren = true;
                }else{
                    this.afterCurren = true;
                }
            }
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.modal-content.mb {
    padding: 10px !important;
}
.modal-content.mb .top-close {
    height: 40px;
}
.modal-content.mb .cart-content {
    max-height: calc(100vh - 300px) !important;
    min-height: 400px;
    height: auto !important;
}
.container{
    width: 100%;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  border-radius: 10px;
  position: relative;
}

/* The Close Button */
.close {
  color: #fff;
  float: right;
  font-size: 15px;
  font-weight: bold;
  border: 1px solid;
  /* border-color: gray; */
  border-radius: 7px;
  padding: 10px;
  background-color: #939393;
  cursor: pointer;
  position: absolute;
  right: 10px;
}

/* .close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
} */
.modal-content .item-image img{
    width: 100px;
}
.modal-content .item-close{
    font-size: 30px !important;
    cursor: pointer;
    color:#cb0d0d;
}
.modal-content .item-total p {
  font-size: 20px;
  padding: 10px 0px;
  border-top: 1px solid #0071c5;
}
.modal-content .item-total span {
  color: #ff3300;
}
.modal-content .cart-content .submit{
    padding: 10px 20px;
    background: #0071c5;
    border: none;
    color: #ffff;
    font-size: 20px;
    border-radius: 5px;
    display: block;
    margin: 0px auto;
    cursor: pointer;
}
.modal-content .cart-content .empty-cart{
     display: block; 
     margin: 10px auto; 
     }
.shopping-cart .button-icon{
    position: fixed;
    right: 25px;
    bottom: 10px;
    z-index: 10;
}
.shopping-cart .button-icon img{
    width: 60px;
    cursor: pointer;
}
.shopping-cart .button-icon .total-item-cart{
    background-color: #ffff;
    border: 1px solid #000;
    padding: 5px;
    border-radius: 20px;
    position: absolute;
    right: 40px;
    top: 0px;
    z-index: 1000;
}
.modal-content .cart-content .cart-table td{
    font-size: 16px;
}
.modal-content .cart-content .cart-table td .item-price-cart {
  color: #ff3300;
}
/* Price */
.style-1 del {
  color: blue;
  text-decoration: none;
  position: relative;
  font-size: 25px;
  font-weight: 700;
}
.style-1 del ::before {
  content: " ";
  display: block;
  width: 100%;
  border-top: 2px solid #cb0d0d;
  height: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: rotate(-7deg);
}
ins {
  color: #cb0d0d;
  font-size: 35px;
  text-decoration: none;
  padding: 1em 1em 1em 0.5em;
  font-weight: 700;
}
@media only screen and (max-width: 1100px) {
    .flex-container > .media-teacher{
        width: 30%;
    }
    /* Price */
   .style-1 del{
       font-size: 20px;
   }
   ins {
       font-size: 25px;
   }
    .modal-content .cart-content .cart-table td{
        font-size: 16px;
        display: block;
    }
    .modal-content .cart-content .cart-table .item-close{
        width: 10%;
        position: relative;
        top: -85px;
        left: 90%;
    }
}
@media only screen and (max-width: 700px) {
    
}
@media only screen and (max-width: 600px) {
    .flex-container {
    display: flex;
    flex-direction: column;
  }
  .flex-container > .media-teacher {
    background-color: rgba(0, 0, 0, 0.6);
    padding: 20px;
    width: 100%;
  }
  .flex-container > .detail_course {
    background-color: rgba(0, 0, 0, 0.6);
    padding: 20px;
    width: 100%;
  }
  .flex-container > .media-course {
    margin: 0px;
    padding: 0px;
    width:100%;
    }
    .flex-container .detail_info-course{
    margin: 0px;
    padding: 10px;
    width:100%;  
    }
    .detail_info-course .box-info span #cart{
        width: 80%;
    }
    .shopping-cart .button-icon{
    position: fixed;
    right: 10px;
    bottom: 60px;
    z-index: 10;
    }
    .cart-content{
    height: 450px;
    overflow-y: scroll;
    }
    .detail_info-course .box-info span #sub{
        width: 80%;
    }
    /* Modal Content */
    .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 90%;
    }
    .modal-content .cart-content .cart-table td{
        display: block;
        font-size: 16px;
    }
    .lesson_content tr td{
        padding: 10px;
        font-size: 14px;
    }
    /* Price */
   .style-1 del{
       font-size: 20px;
   }
   ins {
       font-size: 25px;
   }
}
.Stars {
    --star-size: 30px;
    --star-color: #fff;
    --star-background: #ffc700;
    --percent: calc(var(--rating) / 5 * 100%);  
    display: inline-block;
    font-size: 30px;
    font-family: Times;
    line-height: 1;
}
.Stars::before {
  content: "★★★★★";
  letter-spacing: 3px;
  background: linear-gradient(
    90deg,
    var(--star-background) var(--percent),
    var(--star-color) var(--percent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/detailsSelfCourse/cartCourse.vue